module.exports = __webpack_public_path__ + "static/img/desccomplain.df8344e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desccomplain.jpg
// module id = 2VID
// module chunks = 7